export default __webpack_public_path__ + "static/media/reveal-locks.be1185c4.png";